import React from "react";
import { Link } from "react-router-dom";
import { terms, privacy, refunds, BRAND, LAST_UPDATED } from "./legalContent";

// Página legal genérica: recibe el documento (terms/privacy/refunds) y lo renderiza
// con una maqueta sobria y legible, coherente con la landing.
const styles = {
  page: { backgroundColor: "#f5f5f7", minHeight: "100vh", padding: "40px 16px" },
  card: {
    maxWidth: 860,
    margin: "0 auto",
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: "48px 56px",
    boxShadow: "0 10px 30px rgba(22,28,45,.08)",
    color: "#161C2D",
    fontFamily: "inherit",
    lineHeight: 1.65,
  },
  brandRow: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 },
  updated: { color: "#6b7280", fontSize: "0.85rem", marginBottom: 28 },
  h1: { fontSize: "1.9rem", fontWeight: 800, margin: "0 0 4px" },
  h2: { fontSize: "1.05rem", fontWeight: 700, margin: "26px 0 8px" },
  p: { margin: "0 0 10px", color: "#374151", fontSize: "0.95rem" },
  nav: { display: "flex", gap: 16, marginTop: 36, paddingTop: 20, borderTop: "1px solid #eee", flexWrap: "wrap" },
  link: { color: "#2563EB", textDecoration: "none", fontWeight: 600, fontSize: "0.9rem" },
};

const LegalPage = ({ doc }) => (
  <div style={styles.page}>
    <div style={styles.card}>
      <div style={styles.brandRow}>
        <h1 style={styles.h1}>{doc.title}</h1>
        <Link to="/" style={styles.link}>← {BRAND}</Link>
      </div>
      <div style={styles.updated}>Última actualización: {LAST_UPDATED}</div>
      {doc.sections.map((s) => (
        <div key={s.h}>
          <h2 style={styles.h2}>{s.h}</h2>
          {s.p.map((txt, i) => (
            <p key={i} style={styles.p}>{txt}</p>
          ))}
        </div>
      ))}
      <div style={styles.nav}>
        <Link to="/terminos" style={styles.link}>Términos y Condiciones</Link>
        <Link to="/privacidad" style={styles.link}>Política de Privacidad</Link>
        <Link to="/reembolsos" style={styles.link}>Política de Reembolsos</Link>
      </div>
    </div>
  </div>
);

export const TermsPage = () => <LegalPage doc={terms} />;
export const PrivacyPage = () => <LegalPage doc={privacy} />;
export const RefundsPage = () => <LegalPage doc={refunds} />;
